import { isCartOpen } from '@stores/cartStore'
import 'balloon-css'

const StickyAddToCart = ({ handleAddToCart, currentSize, isUnsizedProduct = false, currentProductTags, handleAddToRegistry, isAddingToCart = false, activeModule = 'individual', matchingFamilySelections = [], hasSizes = false }) => {
    let $isCartOpen = isCartOpen.get()

    const isBabyProduct = currentProductTags && currentProductTags.includes('Baby') && !currentProductTags.some(tag => ['Toddler', 'Kids'].includes(tag))

    // Check if product is coming soon
    const isComingSoon = currentProductTags && currentProductTags.some(tag => tag.includes('comingsoon'))

    // Check if matching family has any items with sizes selected
    const hasMatchingFamilyItemsWithSizes = matchingFamilySelections.some(
        item => item.selectedSize && item.selectedSkuId
    )

    // Determine if button should be disabled (excluding isAddingToCart for proper styling)
    const isButtonDisabled = isComingSoon || (activeModule === 'matching'
        ? !hasMatchingFamilyItemsWithSizes
        : (hasSizes && !isUnsizedProduct && !currentSize.size))

    // Determine if button should be non-clickable (includes loading state)
    const isButtonNonClickable = isButtonDisabled || isAddingToCart

    return (
        <div
            className={`sticky-atc-outer bottom-0 w-full bg-white px-2 pt-2 pb-3 z-[999] border-t border-background-secondary-default fixed md:hidden ${$isCartOpen ? 'hidden' : ''}`}
        >
            {/* Free delivery text */}
            <div className="text-center text-xs text-text-secondary mb-2">
                Free delivery on US orders over $75
            </div>
            <div className="sticky-atc-inner flex items-center justify-center relative gap-2">
                {/* Registry Button */}
                {isBabyProduct && (
                    <div className="product-add-to-registry w-1/2">
                        <div className="registry-actions flex items-center">
                            <button
                                className={`bg-background-secondary-default border border-background-secondary-default text-text-primary rounded-md w-full registry-trigger !text-xs relative !h-12 ${!currentSize.size && !isUnsizedProduct
                                    ? 'disabled noclick opacity-80'
                                    : 'opacity-100 hover:bg-oat'
                                    }`}
                                disabled={(!currentSize.size && !isUnsizedProduct) || isAddingToCart}
                                onClick={handleAddToRegistry}
                            >
                                <span className="flex items-center justify-center gap-2">

                                    <span className="text-base">Add To Babylist</span>
                                </span>
                            </button>
                        </div>
                    </div>
                )}
                <button
                    type="submit"
                    id="pdp-sticky-add-to-cart"
                    className={`rounded-md !h-12 ${
                        isBabyProduct ? 'w-1/2' : 'w-full'
                    } ${
                        isAddingToCart
                            ? 'bg-background-primary-active text-text-primary-inverse cursor-not-allowed'
                            : isButtonDisabled
                            ? 'bg-background-primary-disabled'
                            : 'bg-background-primary text-text-primary-inverse hover:bg-ash opacity-100'
                    }`}
                    disabled={isButtonNonClickable}
                    onClick={(e) => handleAddToCart(e)}
                >
                    <span className={`${isButtonDisabled
                        ? 'text-web-cta-button-1 text-text-primary-disabled'
                        : ''
                    }`}>
                        {isAddingToCart ? 'Adding to bag...' : 'Add To Bag'}
                    </span>
                </button>
            </div>
        </div>
    )
}

export default StickyAddToCart
